import { useTranslation } from 'react-i18next'
import StarRating from './StarRating'

function BookRow({ book, t }) {
  return (
    <div className="border-b border-brand-blue/10 last:border-0 py-4">
      <div className="flex justify-between items-start gap-3">
        <h3 className="font-bold text-brand-blue text-lg">{book.title}</h3>
        <StarRating value={book.rating} size={16} />
      </div>
      <p className="text-base text-brand-blue/80">{book.author}</p>
      <p className="text-sm text-brand-blue/70 mt-1">
        {t('library.history.sent', { date: book.sentDate })}
      </p>
      <p className="text-sm text-brand-blue/70">
        {t('library.myBooks.subscriptionLabel')}: {book.subscriptionDisplayName}
      </p>
      {book.review && (
        <p className="text-base text-brand-blue/80 mt-2 italic line-clamp-3">
          {book.review}
        </p>
      )}
    </div>
  )
}

/**
 * "Moje książki" card for the main Moja Biblioteka dashboard.
 *
 * - 1/3 width on desktop.
 * - Scrollable list of books with a gold scrollbar (no arrow buttons).
 */
export default function MyBooksCard({ items, loading }) {
  const { t } = useTranslation()

  return (
    <div className="lg:col-span-1 bg-[var(--library-card-bg)] backdrop-blur-md rounded-[2rem] p-6 shadow-xl border border-[var(--library-border)] min-h-[400px] flex flex-col">
      <h2 className="font-climate text-2xl text-brand-blue mb-4 shrink-0">
        {t('library.myBooks.title')}
      </h2>

      <div className="flex-1 overflow-y-auto max-h-[600px] gold-scrollbar pr-2">
        {loading ? (
          <p className="text-base text-brand-blue/80">{t('common.loading')}</p>
        ) : items.length === 0 ? (
          <p className="text-base text-brand-blue/80">{t('library.myBooks.empty')}</p>
        ) : (
          items.map((book) => <BookRow key={book.id} book={book} t={t} />)
        )}
      </div>
    </div>
  )
}
